import { createSlice } from "@reduxjs/toolkit";

const initialAccountsState = {
  listLoading: false,
  actionsLoading: false,
  countAccount: 0,
  accountList: null,
  accountForEdit: undefined,
  settingConfigs: null,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const accountsSlice = createSlice({
  name: "accounts",
  initialState: initialAccountsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      }
    },
    // getAccountById
    accountFetched: (state, action) => {
      const { data } = action.payload;
      state.actionsLoading = false;
      state.accountForEdit = data || {};
      state.error = null;
    },
    // findAccounts
    accountsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.accountList = entities;
      state.countAccount = totalCount;
    },
    // createAccount
    accountCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.accountList.push(action.payload.account);
    },
    // updateAccount
    accountUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.accountList = state.accountList.map((entity) => {
        if (entity.id === action.payload.account.id) {
          return action.payload.account;
        }
        return entity;
      });
    },
    // deleteAccount
    accountDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.accountList = state.accountList.filter((el) => el.id !== action.payload.id);
    },
    // deleteAccounts
    accountsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.accountList = state.accountList.filter((el) => !action.payload.ids.includes(el.id));
    },
    // accountsUpdateState
    accountsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.accountList = state.accountList.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    settingConfigsFetched: (state, action) => {
      const { data } = action.payload.data;
      state.listLoading = false;
      state.settingConfigs = data || [];
      state.error = null;
    },
  },
});
